import React, { useEffect, lazy, Suspense, useState } from 'react';
import UserStore from 'stores/UserStore';
import UIStore from '@/stores/UIStore';
import { message, Spin, Typography, Card, Row, Col, Button, Divider } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import FeatherIcon from 'feather-icons-react';
import Feedback from 'components/Feedback';
import { Link } from 'react-router-dom';
import ContactRepForm from 'components/ContactRepForm';
import { PageHeader } from 'components/PageHeader';

const { Text, Paragraph, Title } = Typography;

const Support: React.FC = () => {
    const [visible, setVisible] = useState<boolean>(false);
    const [show_contact_rep, setShowContactRep] = useState(false);

    useEffect(() => {
        UIStore.setSelectedKey(['support']);
        UIStore.setDocumentTitle('Support');
    }, []);

    async function copyToClipboard(info: string) {
        navigator.clipboard.writeText(info);

        message.success(`Copied the text: ${info}`);
    }

    const hasContact = UserStore.isAuthenticated && UserStore.hasAContact;

    return (
        <>
            <PageHeader>
                <div className="d-flex justify-content-between align-items-baseline mb-3">
                    <Title level={1} className="mb-0">
                        Help & Support
                    </Title>
                </div>
            </PageHeader>
            <div className="container">
                <Card bordered>
                    <Row gutter={[24, 24]} className="mb-3">
                        {hasContact ? (
                            <Col md={hasContact ? 8 : 12} span={24}>
                                <div className="text-center">
                                    <Text className="d-flex align-items-center font-size-xl justify-content-center">
                                        <FeatherIcon icon="user" size="32" strokeWidth="1.5" className="mr-2" />
                                        Contact Rep
                                    </Text>

                                    <Button
                                        type="link"
                                        className="font-size-base text-primary"
                                        onClick={() => setShowContactRep(true)}
                                    >
                                        Contact your Sales Representative
                                    </Button>
                                </div>
                            </Col>
                        ) : null}

                        <Col md={hasContact ? 8 : 12} span={24}>
                            <Text className="d-flex align-items-center font-size-xl w-100 justify-content-center">
                                <FeatherIcon icon="phone" size="32" strokeWidth="1.5" className="mr-2" />
                                Call
                            </Text>
                            <div className="w-100 text-center">
                                <a className="link" href="tel:331-223-4378">
                                    (331) 223-4378
                                </a>

                                <Button
                                    type="link"
                                    onClick={() => copyToClipboard('(331) 223-4378')}
                                    icon={<CopyOutlined />}
                                />
                            </div>
                        </Col>

                        <Col md={hasContact ? 8 : 12} span={24}>
                            <Text className="d-flex align-items-center font-size-xl w-100 justify-content-center">
                                <FeatherIcon icon="mail" size="32" strokeWidth="1.5" className="mr-2" />
                                Email
                            </Text>
                            <div className="w-100 text-center">
                                <a className="link" href="mailto:sales@parts-badger.com">
                                    sales@parts-badger.com
                                </a>
                                <Button
                                    type="link"
                                    onClick={() => copyToClipboard('sales@parts-badger.com')}
                                    icon={<CopyOutlined />}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Divider />
                    <div className="w-100 text-center" data-testid="feedback">
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <Text className="d-flex align-items-center font-size-lg w-100 justify-content-center mb-2">
                                <div data-testid="feedback-content">We want to hear from you!</div>
                            </Text>

                            <Button
                                icon={<FeatherIcon icon="message-circle" size="18" strokeWidth="2" className="mr-2" />}
                                size="small"
                                type="primary"
                                className="d-flex align-items-center"
                                onClick={() => setVisible(true)}
                                data-testid="feedback-foot"
                            >
                                Share Your Feedback!
                            </Button>
                        </div>
                    </div>
                </Card>

                <Feedback isQuotes={false} visible={visible} setVisible={setVisible} />

                {show_contact_rep && UserStore.user && (
                    <ContactRepForm current_user={UserStore.user} handleClose={() => setShowContactRep(false)} />
                )}
            </div>
        </>
    );
};

export default Support;
